import React, { useContext } from 'react';
import { c as classnames } from './index-2586sEvh.js';
import { M as MenuItem } from './MenuItem-p_VGbV0y.js';
import Button from './components/Button/index.js';
import { useTranslation } from 'react-i18next';
import { CoreContext } from './context/index.js';
import { C as ConditionalWrapper } from './ConditionalWrapper-6zYfwfM_.js';

const SubMenu = ({ items, extras, visible, onClick, dataParentName }) => {
    if (!Array.isArray(items) || items.length === 0)
        return null;
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { data: { locale, siteConfig: { header: { subMenuImageNoWrapper = false, subMenuExtraImageSize: { width = 0, height = 0 } = {}, } = {}, }, }, } = useContext(CoreContext);
    const extraByLocale = (identifier) => {
        switch (locale) {
            case 'de':
                return extras === null || extras === void 0 ? void 0 : extras[`extra_${identifier}_de`];
            case 'es':
                return extras === null || extras === void 0 ? void 0 : extras[`extra_${identifier}_es`];
            case 'fr':
                return extras === null || extras === void 0 ? void 0 : extras[`extra_${identifier}_fr`];
            default:
                return extras === null || extras === void 0 ? void 0 : extras[`extra_${identifier}`];
        }
    };
    return (React.createElement("div", { className: classnames('sub-menu-wrapper', { visible }) },
        React.createElement("ul", { className: classnames('sub-menu', { visible }) },
            items.map((item, index) => (React.createElement(MenuItem
            // eslint-disable-next-line react/no-array-index-key
            , { 
                // eslint-disable-next-line react/no-array-index-key
                key: `${item.item_id}_${index}`, item: item, onClick: onClick, dataParentName: dataParentName }))),
            extraByLocale('image_text') && (React.createElement("li", { className: "sub-menu-extra" },
                React.createElement("a", { href: extraByLocale('link_url'), rel: "noopener noreferrer", className: "sub-menu-extra-link stack", "data-event-name": "bloc_interact", "data-bloc-name": extraByLocale('image_text') },
                    (extras === null || extras === void 0 ? void 0 : extras.extra_image_one) && (React.createElement(ConditionalWrapper, { condition: !subMenuImageNoWrapper, wrapper: React.createElement("div", { className: "stack-image" }) },
                        React.createElement("img", { src: extras === null || extras === void 0 ? void 0 : extras.extra_image_one, alt: extraByLocale('image_text'), loading: "lazy", ...(width && { width }), ...(height && { height }) }))),
                    React.createElement("div", { className: "stack-content" },
                        React.createElement("span", { className: "title" }, extraByLocale('image_text')),
                        React.createElement("p", null, extraByLocale('description')),
                        React.createElement(Button, null, extraByLocale('link_title') || tButton('shopNow')))))))));
};

export { SubMenu as S };
//# sourceMappingURL=SubMenu-3IxuijNo.js.map
